import * as yup from 'yup';

const validators = (__) => (value) => {
    return (
        yup.object({
            numberPlate: yup.string().required(__(`form.numberPlate.error`)),
            name: yup.string().required(__(`form.name.error`)),
            vin: yup.string().required(__(`form.vin.error`)),
            description: yup.string().required(__(`form.description.error`)),
            transportBrand: yup.string().required(__(`form.transportBrand.error`)),
            idTransportFuelType: yup.number().required(__(`form.idTransportFuelType.error`)),
            division: yup.number().required(__(`form.division.error`)),
            temperature: yup.number().required(__(`form.temperature.error`)),
            kiloXGallon: yup.number().required(__(`form.kiloXGallon.error`)),
            idTransportType: yup.number().required(__(`form.idTransportType.error`)),
            dateExpiration: yup.string().required(__(`form.dateExpiration.error`)),
            datePermission: yup.string().required(__(`form.datePermission.error`)),
        })
    )
}

export default validators
